import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import printJS from 'print-js';
import { Dropdown, DropdownButton, Button } from 'react-bootstrap';
import 'react-photoswipe/lib/photoswipe.css';
import { PhotoSwipe } from 'react-photoswipe';
import { ARRANGEMENT_TYPE_SLUG, LESSON_TYPE_SLUG } from '../../../config';
import shopAPI from '../../../_api/shop';


const ImageGalleryDropdown = ({ can_open_online, offerType, filesList, opener, btnVariant }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [images, setImages] = useState([]);

  const images_url = 'shop/file-images/';

  const handleOpen = (file) => {
    setFile(file);
  }

  const handleClose = () => {
    setIsOpen(false);
    setFile(null);
    setImages([]);
  }

  const handleContextMenu = (e) => {
    e.preventDefault();
  }

  const getImages = async (url) => {
    let images = [];
    const response = await shopAPI.getUserFileImages(url, opener);
    if (response){
      images = response.map(i => ({ src: i.src, w: 1063, h: 1500, title: file.name }));
    }
    return images;
  }

  useEffect(() => {
    if (file){
      const url = images_url + file.id + '/';
      getImages(url).then(response => { setImages(response); setIsOpen(true); });
    }
  }, [file]);

  const openButton = (function(){
    const buttonTitle = <span><i className='icon icon-file-pdf'></i>{' '}
        { offerType === ARRANGEMENT_TYPE_SLUG ? gettext('Открыть Онлайн') : gettext('Читать Онлайн') }
    </span>;

    if (filesList.length > 1){
      const items = filesList.map(f => <Dropdown.Item key={ f.id } as="button" onClick={ () => handleOpen(f) }>{ f.name }</Dropdown.Item>)
      return (
        <DropdownButton title={ buttonTitle }
                        variant={ btnVariant }
                        size='sm'
                        className={'white-space-nowrap'}>
          { items }
        </DropdownButton>
      )
    }
    return (
      <Button variant={ btnVariant } size='sm' onClick={ () => handleOpen(filesList[0]) } className={'white-space-nowrap'}>
        { buttonTitle }
      </Button>
    )
  })

  // const handlePrintClick = () => {
  //   printJS({ printable: images, type: 'image' });
  // }

  if (!can_open_online){
    return null
  }

  return(
    <div onContextMenu={ handleContextMenu } className='mb-2 mb-md-0 d-inline-block'>
      { openButton() }
      { images.length > 0 && <PhotoSwipe isOpen={ isOpen }
                                         items={ images }
                                         onClose={ handleClose }
                                         options={ {index: 0, shareEl: false, closeOnScroll: false } }/> }
    </div>
  )
}

ImageGalleryDropdown.propTypes = {
  can_open_online: PropTypes.bool.isRequired,
  offerType: PropTypes.oneOf([ARRANGEMENT_TYPE_SLUG, LESSON_TYPE_SLUG]).isRequired,
  filesList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  opener: PropTypes.string.isRequired,
  btnVariant: PropTypes.string.isRequired,
}

export default ImageGalleryDropdown;
